import { render, staticRenderFns } from "./grading.vue?vue&type=template&id=17473406&"
import script from "./grading.vue?vue&type=script&lang=js&"
export * from "./grading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports